export const API_BASE_URL = process.env.REACT_APP_BASE_URL;

export const ENDPOINTS = {
  AUTH: {
    LOGIN                      : "auth/login",
    LOGOUT                     : "auth/logout",
    REFRESH                    : "auth/refresh",
    GOOGLE                     : "auth/google",
    GOOGLE_CALENDAR_STATUS     : "auth/google/calendar/status",
    GOOGLE_CALENDAR_CONNECT_URL: "auth/google/calendar/connect-url",
    LINKEDIN                   : "auth/linkedin",
    REGISTER                   : "auth/register",
    STOP_IMPERSONATION         : "auth/stop-impersonation",
   },
  REPORTS: {
    GET_REPORTS          : "reports",
    GET_DEVELOPER_REPORTS: "reports/developer",
    TIME_TRACKING        : "reports/time-tracking",
  },
  TIME_DOCTOR: {
    GET_SCREENSHOTS: "time-doctor/files",
    GET_USERS      : "time-doctor/users",
    GET_PROJECTS   : "time-doctor/projects",
  },
  HIRING: {
    GET_HIRING    : "hiring",
    GET_HIRING_DEV: "hiring/:id",
  },
  INTERVIEWS: {
    CREATE_INTERVIEW              : "interviews",
    UPDATE_INTERVIEW              : "interviews",
    DELETE_INTERVIEW              : "interviews",
    GET_INTERVIEWS_BY_DEV         : "interviews/dev",
    GET_UNAVAILABLE_INTERVIEW_TIME: "interviews/dev/unavailable",
  },
  USERS_LIST: {
    GET_USERS                      : "users",
    GET_ADMIN_USERS                : "admin/users",
    GET_AVAILABLE_USERS_FOR_PROJECT: "admin/users/availableToAdd",
  },
  PROFILE : { DEVELOPER: "users/developer", },
  PROJECTS: {
    GET_PROJECTS      : "projects",
    GET_SINGLE_PROJECT: "projects/:id",
    HIRE_DEVELOPER    : "projects/developer",
  },
  SKILLS  : { GET_SKILLS: "skills", },
  TEAM    : { DEVELOPER: "users/team/develop", },
  USERS   : { GET_USERS: "users", },
  INVOICES: {
    GET_INVOICES           : "invoices",
    GET_INVOICES_BY_PROJECT: "invoices/projects/:id",
    GENERATE_CHECKOUT_LINK : "invoices/:id/checkout-link",
    GET_SERVICE_NAMES      : "admin/invoices/service-names",
  },
  EMAIL: {
    SEND_VERIFICATION: "email-verification/send-verification",
    VERIFY_EMAIL     : "email-verification/verify-email",
  },
  RESET_PASSWORD: {
    SEND_RESET_CODE         : "auth/send-reset-code",
    VERIFY_RESET_CODE       : "auth/verify-reset-code",
    RESET_PASSWORD          : "auth/reset-password",
    INTERNAL_UPDATE_PASSWORD: "auth/update-password",
  },
  ADMIN: {
    PROJECTS: {
      LIST                : "admin/projects",
      RENORMALIZE_PROJECTS: "admin/projects/renormalize-projects",
    },
    COMPANY: {
      LIST  : "admin/companies",
      DELETE: "admin/companies/:id",
      UPDATE: "admin/companies/:id",
    },
    DEVS    : { LIST: "admin/devs", OPTIONS: "admin/devs/options" },
    ROLES   : { LIST: "admin/roles", },
    USERS   : { LIST: "admin/users", },
    DAYOFFS : { LIST: "admin/dayoffs", },
    INVOICES: {
      ALL                            : "admin/invoices",
      LIST                           : "admin/invoices/project/:id",
      CREATE                         : "admin/invoices",
      UPDATE                         : "admin/invoices/:id",
      CALCULATE_TIME_APPROACH_DETAILS: "admin/invoices/calculate-invoice-details",
      DELETE                         : "admin/invoices/:id",
      MARK_PAID                      : "admin/invoices/:id/payment",
      REVERT_PAYMENT                 : "admin/invoices/:id/payment/revert",
      STATUS_EVENTS                  : "admin/invoices/:id/status-events",
    },
    SCOPES: {
      CREATE : "admin/scopes",
      UPDATE : "admin/scopes/:id",
      DELETE : "admin/scopes/:id",
      PROJECT: "admin/scopes/project/:id",
    },
    GIT_TOKEN: {
      GET   : "git/token/:devId",
      ADD   : "git/token/:devId",
      UPDATE: "git/token/:devId/:tokenId",
      DELETE: "git/token/:devId/:tokenId",
    },
    MEETINGS: { LIST: "admin/meetings", },
    REPORTS : { LIST: "admin/reports", },
  },
  MEETINGS: { LIST: "meetings", },
  FEEDBACK: {
    CREATE        : "feedback",
    ATTACHMENT_URL: "feedback/attachments/:id/url",
  },
  GIT_HISTORY: {
    GET    : "git/history",
    REFRESH: "git/history/refresh" // force parsing existing repository
  },
  CONVERSATIONS: {
    GET_CONVERSATIONS  : "conversations",
    GET_CONVERSATION   : "conversations/:id",
    CREATE_CONVERSATION: "conversations",
    WIZARD_START       : "conversations/wizard/start",
    UPLOAD_FILES       : "conversations/:conversationId/upload",
    CLAIM              : "conversations/:id/claim",
  },
  PUBLIC_CONVERSATIONS: {
    CREATE      : "public/conversations",
    GET         : "public/conversations/:id",
    SEND_MESSAGE: "public/conversations/:id/messages",
    UPLOAD_FILES: "public/conversations/:id/upload",
  },
  ESTIMATION_REQUESTS: {
    GET_ESTIMATION_REQUESTS    : "client-requests",
    GET_ESTIMATION_REQUEST     : "client-requests/:id",
    UPDATE_LEGAL_DATA          : "client-requests/:id/legal-data",
    UPDATE_FILE_STATUS         : "client-requests/:id/files/:fileId/status",
    GET_DOCUSIGN_SIGNING_URL   : "client-requests/:id/docusign-signing-url",
    GET_FILE_SIZE              : "client-requests/files/file-size",
    GET_STATUSES               : "admin/client-requests/statuses",
    GET_MANUAL_STATUSES        : "admin/client-requests/statuses/manual",
    GET_LIST                   : "admin/client-requests",
    GET_BY_ID                  : "admin/client-requests/:id",
    UPDATE                     : "admin/client-requests/:id",
    DELETE                     : "admin/client-requests/:id",
    CREATE_ESTIMATION_FILE     : "admin/client-requests/:id/estimation-files",
    UPDATE_ESTIMATION_FILE     : "admin/client-requests/estimation-files/:fileId",
    DELETE_ESTIMATION_FILE     : "admin/client-requests/estimation-files/:fileId",
    SEND_FOR_SIGNATURE         : "admin/client-requests/:id/send-for-signature",
    CREATE_CONTRACT_FILE       : "admin/client-requests/:id/contract-files",
    UPDATE_CONTRACT_FILE       : "admin/client-requests/contract-files/:fileId",
    DELETE_CONTRACT_FILE       : "admin/client-requests/contract-files/:fileId",
    UPDATE_CONTRACT_FILE_STATUS: "client-requests/:id/contract-files/:fileId/status",
    GET_CONTRACT_DOCUSIGN_URL  : "client-requests/:id/contract-files/:fileId/docusign-signing-url",
    ADD_SPECIALIST_CANDIDATE   : "admin/client-requests/:id/specialist-candidates",
    REMOVE_SPECIALIST_CANDIDATE: "admin/client-requests/specialist-candidates/:candidateId",
  },
  DOCUMENTS   : { GET_RECIPIENT_VIEW_URL: "documents/recipient-view-url", },
  CLIENT_CALLS: {
    CREATE_MEETING      : "client-calls",
    UPDATE_MEETING      : "client-calls",
    GET_UNAVAILABLE_TIME: "client-calls/unavailable-time",
  },
  BANK_DETAILS: {
    GET_ALL                           : "bank-details",
    GET_BY_REGION_AND_CURRENCY        : "bank-details/:region/:currency",
    UPDATE_BY_REGION_AND_CURRENCY     : "bank-details/:region/:currency",
    DELETE_BY_REGION_AND_CURRENCY     : "bank-details/:region/:currency",
    CREATE_CURRENCY_REGION_COMBINATION: "bank-details/currency-region-combination",
    GET_CURRENCY_COMBINATIONS         : "bank-details/currency-combinations",
   },
};
